import * as types from './types';

const fetchLeads = params => ({ type: types.FETCH_LEADS, payload: params });
const fetchLeadsOther = params => ({ type: types.FETCH_LEADS_SUCCEEDED_OTHER, payload: params });
const fetchLeadsPhoneCall = params => ({ type: types.FETCH_LEADS_SUCCEEDED_PHONECALL, payload: params });
const fetchLeadsWh = params => ({ type: types.FETCH_LEADS_SUCCEEDED_WH, payload: params });
const fetchLeadsEmails = params => ({ type: types.FETCH_LEADS_SUCCEEDED_EMAIL, payload: params });

const fetchLeadsUpdateStatus = data => ({ type: types.FECTH_LEAD_UPDATE_STATUS, payload: data });
const fetchLeadsUpdateStatusFailed = data => ({ type: types.FECTH_LEAD_UPDATE_STATUS_FAILED, payload: data });
const fetchLeadsUpdateStatusSuccess = data => ({ type: types.FETCH_LEADS_STATUS_SUCCEEDED, payload: data });

const fetchLeadsStatus = data => ({ type: types.FETCH_LEADS_STATUS, payload: data });

const fetchLeadsSucceeded = data => ({ type: types.FETCH_LEADS_SUCCEEDED, payload: data });

const fetchLeadsFailed = data => ({ type: types.FETCH_LEADS_FAILED, payload: data });

const fetchPublisher = data => ({ type: types.FETCH_PUBLISHER, payload: data });
const fetchPublisherSucceeded = data => ({ type: types.FETCH_PUBLISHER_SUCCEEDED, payload: data });
const fetchPublisherFailed = data => ({ type: types.FECTH_LEAD_UPDATE_STATUS_FAILED, payload: data });

const fetchLeadsMobileSucceeded = data => ({ type: types.FETCH_LEADS_MOBILE_SUCCEEDED, payload: data });

const fetchLeadsMobileSucceededEvent = data => ({
  type: types.FETCH_LEADS_MOBILE_SUCCEEDED_UPDATE_EVENT,
  payload: data
});

const fetchLeadsMobile = data => ({ type: types.FETCH_LEADS_MOBILE, payload: data });

const selectedLead = lead => ({ type: types.SELECTED_LEAD, payload: lead });

const unSelectedAllLeads = () => ({ type: types.UNSELECTED_ALL_LEADS });

const changePage = offset => ({ type: types.CHANGE_PAGE, payload: offset });

const changeFilter = data => ({ type: types.CHANGE_FILTER, payload: data });

const updateLeadStatusFavorite = lead => ({ type: types.UPDATE_LEAD_STATUS_FAVORITE, payload: lead });

const updateLeadStatusFavoriteSucceeded = data => ({
  type: types.UPDATE_LEAD_STATUS_FAVORITE_SUCCEEDED,
  payload: data
});

const updateLeadStatusFavoriteFailed = data => ({ type: types.UPDATE_LEAD_STATUS_FAVORITE_FAILED, payload: data });

const showSnackBar = snackBarOptions => ({ type: types.SHOW_SNACKBAR, payload: snackBarOptions });

const hideSnackBar = () => ({ type: types.HIDE_SNACKBAR });

const updateLeadStatus = lead => ({ type: types.UPDATE_LEAD_STATUS, payload: lead });

const updateLeadStatusSucceeded = data => ({ type: types.UPDATE_LEAD_STATUS_SUCCEEDED, payload: data });

const updateLeadStatusFailed = data => ({ type: types.UPDATE_LEAD_STATUS_FAILED, payload: data });

const updateLeadsSucceededBackground = data => ({ type: types.UPDATE_LEADS_IN_BACKGROUND_SUCCEEDED, payload: data });

const updateLeadStatusMobileSucceeded = data => ({ type: types.UPDATE_LEADS_STATUS_SUCCEEDED_MOBILE, payload: data });

const notShowLoading = data => ({ type: types.NOT_SHOW_LOADING, payload: data });

const changeTabOption = tab => ({ type: types.CHANGE_TAB_OPTION, payload: tab });

const updateTabOption = data => ({
  type: types.UPDATE_TAB_OPTION,
  payload: data
});
const resetTabOption = tab => ({ type: types.RESET_TAB_OPTION, payload: tab });

const updateTabNew = data => ({
  type: types.UPDATE_TAB_NEW,
  payload: data
});

const updateTabNewFalse = data => ({
  type: types.UPDATE_TAB_NEW_FALSE,
  payload: data
});

const updateTabDisplay = data => ({
  type: types.UPDATE_TAB_DISPLAY,
  payload: data
});

export {
  notShowLoading,
  changePage,
  updateLeadStatusMobileSucceeded,
  updateLeadsSucceededBackground,
  fetchLeadsMobile,
  fetchLeadsMobileSucceeded,
  fetchLeadsMobileSucceededEvent,
  fetchLeads,
  fetchLeadsSucceeded,
  fetchLeadsFailed,
  selectedLead,
  unSelectedAllLeads,
  updateLeadStatusFavorite,
  updateLeadStatusFavoriteSucceeded,
  updateLeadStatusFavoriteFailed,
  updateLeadStatus,
  updateLeadStatusSucceeded,
  updateLeadStatusFailed,
  showSnackBar,
  hideSnackBar,
  changeTabOption,
  resetTabOption,
  updateTabOption,
  updateTabNew,
  updateTabNewFalse,
  updateTabDisplay,
  fetchLeadsStatus,
  fetchLeadsUpdateStatus,
  fetchLeadsUpdateStatusFailed,
  fetchLeadsUpdateStatusSuccess,
  fetchPublisher,
  fetchPublisherSucceeded,
  fetchPublisherFailed,
  changeFilter,
  fetchLeadsOther,
  fetchLeadsPhoneCall,
  fetchLeadsWh,
  fetchLeadsEmails
};
